// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__DKJH4","file":"styles_file__3tBUw"};